<template>
<app-layout>
<!-- searchbox -->

  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
  <div class="grid grid-cols-6 gap-4">
    
     <aside class=" left-0 min-h-screen" style="">
    
    <ul class="flex flex-col items-center my-8">
      <h5 class="mt-8 mr-4 font-semibold">Filter by category</h5>
         <div class=" w-full  text-gray-600 mt-4">
          
        <label id="tally" title="Dashboard">
          <input type="checkbox" class=" mr-3 sm:mr-1">
         Dashboard
           </label>
        </div>
      <!--  -->
      
    
        <div class=" w-full  text-gray-600">
        <label id="int" title="Integrate">
          <input type="checkbox" class="mr-3">
         Integrate
           </label>
        </div>
  
      <!--  -->
          <div class=" w-full  text-gray-600">
        <label id="int" title="Manage">
          <input type="checkbox" class="mr-3">
         Manage
           </label>
        </div>
      <!--  -->

         <div class=" w-full  text-gray-600">
        <label id="int" title="Print">
          <input type="checkbox" class="mr-3">
         Print
           </label>
        </div>

      <!--  -->

          <div class=" w-full  text-gray-600">
        <label id="int" title="Report">
          <input type="checkbox" class="mr-3">
         Report
           </label>
        </div>

      <!--  -->

        <div class=" w-full  text-gray-600">
        <label id="int" title="Analyse">
          <input type="checkbox" class="mr-3">
         Analyse
           </label>
        </div>

      <!--  -->

        <div class=" w-full  text-gray-600">
        <label id="int" title="Sync">
          <input type="checkbox" class="mr-3">
          Sync
           </label>
        </div>

      <!--  -->

       <div class=" w-full text-gray-600 " >
        <label id="tally" title="Tally-on-Cloud">
          <input type="checkbox" class="mr-3">
          Tally-on-Cloud
           </label>
        </div>
      <!--  -->

          <div class=" w-full  text-gray-600">
        <label id="int" title="Add-Ons">
          <input type="checkbox" class="mr-3">
         Add-Ons
           </label>
        </div>
      <!--  -->

          <div class=" w-full  text-gray-600">
        <label id="int" title="Modules">
          <input type="checkbox" class="mr-3">
         Modules
           </label>
        </div>

      <!--  -->

          <div class=" w-full  text-gray-600">
        <label id="int" title="Service">
          <input type="checkbox" class="mr-3">
          Services
           </label>
        </div>

      <!--  -->

            <div class=" w-full  text-gray-600">
        <label id="int" title="Training">
          <input type="checkbox" class="mr-3">
           Trainings
           </label>
        </div>

      <!--  -->

       <div class=" w-full  text-gray-600">
        <label id="int" title="Webinars">
          <input type="checkbox" class="mr-3">
         Webinars
           </label>
        </div>

      <!--  -->
    </ul >
     
            <h6 class="text-gray-600  ml-1 font-bold">Account</h6>
               <ul class="flex flex-col items-center mt-2">
                <!--  -->

              <div class=" w-full  text-gray-600">
        <label id="tally" title="Help & Support">
          <input type="checkbox" class=" check mr-3">
         Help & Support
           </label>
        </div>

            <!--  -->
        
                <div class=" w-full  text-gray-600">
        <label id="int" title="Settings">
          <input type="checkbox" class="mr-3">
          Settings
           </label>
        </div>
            
              <!--  -->
             
               <div class=" w-full  text-gray-600">
        <label id="int" title=" Log-Out">
          <input type="checkbox" class="mr-3">
           Log-Out
           </label>
        </div>
                
                
              </ul>
</aside>
    <div class="col-container-parent" style="background:#f3f4f6"> 
      <div class="flex justify-between  gap-4 my-4 ml-4 search-container search">
      <div class="text-xl font-semibold text-green-500">Marketplace</div>
      <div class="flex justify-end search_hide border-green-200">
         <input type="text" class="px-4 py-2 search_input " placeholder="Search...">
        <button class="px-4 text-white bg-green-500 border-l ">
            Search
        </button>
      </div>
       </div>
        <!-- button -->
         <div class="flex justify-between  gap-4 my-4 ml-4 search-container search_small">
      <div class="text-xl font-semibold text-green-500">Marketplace</div>
     <div class="search-box flex justify-end">
            <input class="search-input" type="text" name="" placeholder="Search">
            <a href="#" class="search-btn">
              <i class="fas fa-search"></i>
            </a>     
          </div>
       </div>
          
        <!-- button end -->
   
      <!-- <div class="card-container items-center flex justify-between  gap-4 my-4 ml-4">
        <div class="text-xl font-semibold text-green-500">Marketplace</div>  
    <div class="flex  border-green-200 rounded justify-end">
        <input type="text" class="px-4 py-2 search_input " placeholder="Search...">
        <button class="px-4 text-white bg-green-500 border-l ">
            Search
        </button>
    </div>
      </div> -->
      <div class="card-container">
          <div class="card" v-for="(v, k) in products" :key="k">
            <main class="card-header ">
              <div class="icon1">
             <i class="fab fa-font-awesome"></i>
              </div>
              <p class="header-title">{{v.name}}</p>
              <p title="Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quasi voluptatem at provident!" id="paragraph">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quasi voluptatem at provident!</p>
               <div class="d-flex  flex-row relative">
               <a href="" class="floating-button1 left-2">More Info</a>
              &nbsp;  &nbsp;  &nbsp;  &nbsp; 
               <jet-button @click="deployItem(v.id)" href="" class="floating-button0 absolute  right-2">Install</jet-button>
               </div>
            </main>
          </div>
         
        </div>

      
        </div>
  </div>
  </div>
   
    <!-- lowe cards start from here -->
    
          <!-- lower cards end here --> 
</app-layout>   
</template>
<script>
import AppLayout from '@/Layouts/AppLayout.vue';
import JetNavLink from '@/Jetstream/NavLink.vue'
import JetButton from "@/Jetstream/Button.vue";
export default {
   props: {
    products: Array,
    moduleRoute: String,

  },
    components:{
        AppLayout,
        JetNavLink,
        JetButton,
        //  DxToast,
    },
   data() {
      return {
      testData: [
        {
          name: "Bar Code",
        },
        {
          name: "SMS",
        },
        {
          name: "Email",
        },
        {
          name: "Data Import",
        },
        {
          name: "Sales to Purchase",
        },
        {
          name: "Footwear",
        },
        {
          name: "Tata Motors",
        },
        {
          name: "Broker",
        },
        {
          name: "Pharma",
        },
      ],
      };
  },  
  methods: {
      deployItem($id){
    
      //console.log("Selected Id".$id);
      this.$inertia.get(route(this.moduleRoute+".deploy",$id));
     // route(this.moduleRoute+".deploy",$id);

      }
      

    },
    mounted() {
      console.log("products Data",this.products[0].id);
      console.log("ModelRoute",this.moduleRoute);
    },
}
</script>
<style>

/* Test -Start */
.col-container-parent{
  grid-column: span 5 / span 5;
}

/* Test -End */
/* lower card start from here */
.main-content{
  	margin-left: 212px;
}

.card-container {
  /* margin: 1rem; */
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  algin-items: center;
  margin-left: 30px;
   margin-right: 30px;
  margin-top: 10px; 
}
.search-container {
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  algin-items: center;
  margin-left: 30px;
   margin-right: 30px;
  margin-top: 10px; 
}

.card {
   background-color: white;
  border-radius: .50rem;
  border: 1px solid white;
  overflow: hidden;
}
.card-header .header-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1px;
  margin-top: 1px;
  color: black;
}
.header-para{
   font-size: 1rem;
  font-weight: bold;
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.card-header {
    margin-bottom: 0;
    background-color: white;
    border-bottom: white;
}
.icon1{
  font-size: 50px;
  color: #10b981;
}
/* lower button0 lower card */
.floating-button0 {
  text-decoration: none;
  height: 40px;
  border-radius: 5px;
  line-height: 40px;
  /* margin: 10px 20px; */
  text-align: center;
  font-weight:bolder;
  color: black;
}
.floating-button0:hover {
  background: #10b981;
  box-shadow: #10b981;
  color: white;
  /* transform: translateY(-5px); */
}
/* lower button0 lower card */
.floating-button1 {
  text-decoration: none;
  display: inline-block;
  width: 90px;
  height: 40px;
  line-height: 40px;
  font-weight:bolder;
  color: black;
}
.floating-button1:hover {
  color: #10b981; 
}
.recommend{
  margin-left: 33px;
}
/* lower card end here */
/* header page */
header{
  /* overflow: hidden; */
  position: fixed;  /* Set the navbar to fixed position */
  top: 0; 
  padding:14px 50px;
  width: 86%;
  display:flex;
  justify-content:space-between;
  background:white;
  border: 1px solid rgb(230, 228, 228);
 	margin-left: 210px;
   z-index: 1;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 648px) {
  .search{
  display: none;
}
.search_small {
  display: block;
}
 header{
width: 37%;
  }
 #int{
     width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; 
  }
  #tally {
   width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
} 
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 648px) {
  header{
width: 57%;
  }
  #int{
     width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; 
  }
  #tally {
   width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
 .search_small{
  display: none;
}
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  header{
width: 76%;
  }
 
  #tally {
   width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
 .search_small{
  display: none;
}
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  header{
width: 82%;
  }
  .search_small {
  display: none;
}
#tally {
   width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
 .search_small{
  display: none;
}
 
}
@media only screen and (min-width: 1280px) {
  header{
width: 86%;
  }
  .search_small {
  display: none;
}
 #tally {
   width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} 
}
 @media only screen and (min-width: 1536px) {
  #tally {
   width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} 
 .search_small {
  display: none;
}
 }

.nav-list{
  display:flex;
  flex-flow : row-reverse wrap;
  justify-content: space-around;
  align-items: center;
}
.nav-list li{
  display:inline-block;
  padding:10px;
  margin: 4px;
  width:auto;
  border-radius: 10px;
}
 /* button start */
.search-box {
  position: absolute;
  left: 80%;
  transform: translate(-65%,-80%);
  background: white;
  /* height: 50px; */
  border-radius: 50px;
}
.search-btn {
  color: white;
  float: right;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #10B981;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 2s;
}

.fa-search {
  background: #10B981;
  font-size: 24px;
}

.search-input {
  border: none;
  background: none;
  outline: none;
  float: left;
  padding: 0;
  color: white;
  font-size: 20px;
  transition: 0.4s;
  line-height: 50px;
  width: 0;
}

.search-box:hover > .search-input {
  width: 180px;
  padding: 0 7px;
}
 /* button end */
</style>